var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendingError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.159,
    height: 20,
    viewBox: "0 0 22.159 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sending_Error",
    "data-name": "Sending Error",
    transform: "translate(-1177.069 -959.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_547",
    "data-name": "Caminho 547",
    d: "M20.057,22H3.943a3.023,3.023,0,0,1-2.618-4.534L9.382,3.511a3.023,3.023,0,0,1,5.235,0l8.057,13.955A3.023,3.023,0,0,1,20.057,22Z",
    transform: "translate(1176.148 957.5)",
    fill: "#ffd7ca"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_181",
    "data-name": "Elipse 181",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(1187.148 973.5)",
    fill: "#ef4411"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_548",
    "data-name": "Caminho 548",
    d: "M12,14a1,1,0,0,1-1-1V9a1,1,0,0,1,2,0v4A1,1,0,0,1,12,14Z",
    transform: "translate(1176.148 957.5)",
    fill: "#ef4411"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendingError);
export default __webpack_public_path__ + "static/media/Sending Error.a9f081a3.svg";
export { ForwardRef as ReactComponent };